Demo.CATEGORY_CONFIG = [{
    id: 100000,
    text: "专题"
}, {
    pId: 100000,
    text: "可以排序的树",
    value: "demo.sort_tree"
}];